import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  /* Function for Encrypting tokens with 128bit, need to pass secret_key and token */
  set(keys, value) {
    let key = CryptoJS.enc.Utf8.parse(keys);
    let iv = CryptoJS.enc.Utf8.parse(keys);
    let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  /* Function for Decrypting tokens from 128bit, need to pass secret_key and token */
  get(keys, value) {
    if (value != null) {
      let key = CryptoJS.enc.Utf8.parse(keys);
      let iv = CryptoJS.enc.Utf8.parse(keys);
      let decrypted = CryptoJS.AES.decrypt(value, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      try {
        return decrypted.toString(CryptoJS.enc.Utf8);
      } catch (error) {
        return false;
      }
    }
  }
}
